import React, {Component, Suspense, useEffect, useState} from 'react';
import {Redirect, withRouter} from "react-router-dom";
import {errorlog, renderlog, showlog} from "../../../utils/dev-utils";
import {
  Alert, Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Collapse,
  CustomInput,
  FormGroup,
  Input,
  Label,
  NavLink,
  Popover,
  PopoverBody,
  PopoverHeader,
  Progress,
  Row, UncontrolledPopover
} from "reactstrap";
import {
  COLOR_POLICY,
  HELPER,
  MAGNITUDE_DARK,
  PATH_PREFIX,
  PERIMETRAL_QUESTION_TO_AVOID,
  permissions,
  RATING_STATUS,
  role
} from "../../../env";
import Select from "react-select";
import PageTitle from "../../../components/PageTitle";
import ActionButton from "../../../components/save-button";
import {getLastElementOr, isNotEmptyArray, onlyNotNull} from "../../../utils/array-utils";
import {WaitingOrNodataMessage} from "../../../components/waiting-or-nodata-message";
import "../../../style/audit.css";
import {
  getEvaluationStatus, loadPerimeterLookup, loadCcnlContracts, loadOrganizationTypes, loadPerimeterQuestions,
  loadProfilingData, loadWorldCountries,
  savePerimetral,
  saveProfilingAnswer, checkQuestionStatus
} from "../../../business-logic/rating";
import {beautify, cloneObject} from "../../../utils/object-utils";
import {loadEvaluations} from "../../../business-logic/active-service";
import {hasPermission, isUserRole} from "../../../business-logic/auth";
import SectorListPopup from "../../../components/area/super-admin/sector-list-modal";
import {emoj, extractErrorMessage} from "../../../utils/string-utils";

import {TreeToggler} from "../../../components/tree-toggler";
import GotoTopComponent from "../../../components/goto-top-component";
import {translate} from '../../../components/i18n/translate-function';
import {RenderQuestions} from "./perimetral-question-render-component";
import ErrorMessageModalComponent from "../../../components/error-message-modal-component";
import {
  cloneOpenNodes,
  getQuestionPath,
  getQuestionTreeNodeByPath
} from "../../../business-logic/question-tree-manager";
import SiRatingQuestionAttachmentModal from "./sirating-question-attachment-modal";
import PerimeterQuestionAttachmentModal from "./perimeter-question-attachment-modal";
import {httpTimer} from "../../../utils";
import Spinner from "../../../components/Spinner";
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';


const fieldMap = {
  id: "id",
  codCliFor: "companyId",
  name: "Nome",
  dateCreate: translate("Creation Date"),
  ragioneSociale: "Ragione Sociale",
  dimensionName: "Dimensione",
  state: "Status",
  scoreButton: "Punteggio",
  files: translate("Attachments")
};
let questionChildren = []

type QuestionTypes = [
  1, // campo input alfanumerico
  2, // campo input numerico
  3, // campo input allegato
  4, // scelta singola
  5, // scelta multipla
  6, // scelta singola con campi input
  7, // scelta multipla con campi input
  8, // lista con selezione singola
  9, // lista con selezione multipla
  10, // lista con selezione singola con campo input
  11, // lista con selezione multipla con campo input
];
type ListTypes = [
  "codici_ateco",
  "paesi",
  "certificazioni_volontarie"
]
type AttachemntTypes = [
  0, // non richiesto
  1, // allegato facoltativo,
  2, // allegato obbligatorio
]


interface PerimeterQuestion {
  questionId: number,
  attachmentCondition: string,
  attachmentType: AttachemntTypes,
  attachmentsPosition: string[],
  questionType: QuestionTypes,
  question: string,
  subQuestion?: string,
  choices: (string | { list: ListTypes, answerType: QuestionTypes } | PerimeterQuestion)[],
  answers: (string | number | { selected: number, value: string | number })[],
  isComplete: boolean,
  isOpen: boolean
}

function SIRatingPerimetralQuestionPage(props) {
  renderlog("SIRatingPerimetralQuestionPage");
  showlog('props to check', props);

  const [ready, setReady] = useState(false)
  const [data, setData] = useState({status: 0, questions: [], lookup: null})
  const [inWait, setInWait] = useState(true)
  const [error, setError] = useState("")
  const [alertOpen, setAlertOpen] = useState(false)
  const [alertMessage, setAlertMessage] = useState("false")
  const [activeFilter, setActiveFilter] = useState(-1)
  const [attachmentModal, setAttachmentModal] = useState(null)
  const [redirectPath, setRedirectPath] = useState("")
  const [waitingConfirm, setWaitingConfirm] = useState(false)
  const [waitingPDF, setWaitingPDF] = useState(false)

  const evaluationId = props.match?.params?.id
  const companyId = props.location?.state?.companyId

  const goAwayPath = PATH_PREFIX + "/super-admin/si-rating/" + translate("evaluations");
  const evaluationPath = PATH_PREFIX + "/sirating-admin/" + translate("evaluation") + "/" + evaluationId;
  // const configurationPath = PATH_PREFIX + "/si-rating/" + translate("evaluation") + "/" + companyId;
  const configurationPath = PATH_PREFIX + "/si-rating/" + translate("evaluation") + "/" + evaluationId;

  const inWaiting = <div>Wait</div>;

  useEffect(() => {
    loadData()
  }, []);

  function isReadOnly() {

    // permesso di chiudere la profilazione
    let closePermission = !!hasPermission(permissions.CLOSE_PERIMETRAL_QUESTION);

    // ARB OPERATOR and state 3
    let isAdminRole = (
      (
        isUserRole(role.ADMIN) ||
        isUserRole(role.SR_ADMIN)
      ) &&
      (
        Object.keys(RATING_STATUS)
          .map(key => RATING_STATUS[key])
          .filter(status => status.name === data.status)
          .reduce(getLastElementOr, {id: 0})
          .id !== RATING_STATUS.perimetralQuestionInProgress.id
      )
    );

    // ARB OPERATOR and state 4

    const canARBOperatorsEdit = (
      (isUserRole(role.ARB_OPERATOR) || isUserRole(role.PROJECT_MANAGER)) &&
      (
        Object.keys(RATING_STATUS)
          .map(key => RATING_STATUS[key])
          .find(status => status.id === data.status)
          ?.id === RATING_STATUS.perimetralQuestionCompleted.id
      )
    )

    const canAdminsEdit = (
      (isUserRole(role.ADMIN) || isUserRole(role.SR_ADMIN)) && (
        Object.keys(RATING_STATUS)
          .map(key => RATING_STATUS[key])
          .find(status => status.id === data.status)
          ?.id === RATING_STATUS.perimetralQuestionInProgress.id
      )
    )


    // // ARB OPERATOR and state 3
    // let operatorAndState_done = (
    //   isUserRole(role.ARB_OPERATOR) &&
    //   (
    //     Object.keys(RATING_STATUS)
    //       .map(key => RATING_STATUS[key])
    //       .filter(status => status.name === data.status)
    //       .reduce(getLastElementOr, {id: 0})
    //       .id !== RATING_STATUS.perimetralQuestionCompleted.id
    //   )
    // );
    //
    // // Project Manager and state 5
    // let pmAndState_done = (
    //   isUserRole(role.PROJECT_MANAGER) &&
    //   (
    //     Object.keys(RATING_STATUS)
    //       .map(key => RATING_STATUS[key])
    //       .filter(status => status.name === data.status)
    //       .reduce(getLastElementOr, {id: 0})
    //       .id !== RATING_STATUS.perimetralQuestionValidated.id
    //   )
    // );

    // return (!!closePermission && !(pmAndState_done || operatorAndState_done));

    // return (!!closePermission && !(isAdminRole));

    // showlog('data.status', data.status);
    //
    // showlog('closePermission', closePermission);
    //
    // showlog('canAdminsEdit', canAdminsEdit);
    // showlog('canARBOperatorsEdit', canARBOperatorsEdit);

    return !(closePermission && (canAdminsEdit || canARBOperatorsEdit));
  }

  async function loadData() {
    try {
      const [status, perimeterQuestions, lookup] = await Promise.all([
        props?.location?.state?.status ? Promise.resolve(props.location.state.status) : getEvaluationStatus(evaluationId),
        loadPerimeterQuestions(evaluationId),
        loadPerimeterLookup(evaluationId)
      ])

      showlog('status obtained', status);
      showlog('perimeterQuestions', perimeterQuestions);
      showlog('lookup', lookup);

      setData({
        status: status,
        questions: checkQuestions(perimeterQuestions, lookup),
        lookup: lookup
      })
    } catch (e) {
      errorlog("in loadData()", e)
      setError(e)
    } finally {
      setInWait(false)
    }
  }

  function updatePerimeterQuestion(id, body) {
    try {

      const questions = [...(data.questions || [])]
      const index = questions?.findIndex(q => q.id === id)
      questions[index] = {...questions[index], answers: body, isComplete: true}
      setData({...data, questions})
      checkIfQuestionsAreCompleted(questions)

    } catch (e) {
      errorlog("error in updatePerimeterQuestion()", e)
    }
  }

  function updatePerimeterQuestionAttachmentsNumber(id, increment, count = 0) {
    try {

      const questions = [...(data.questions || [])]
      const index = questions?.findIndex(q => q.id === id)
      const attachmentsNumber = questions[index]?.attachmentsNumber || 0
      if (increment) questions[index] = {...questions[index], attachmentsNumber: (attachmentsNumber + count)}
      else questions[index] = {...questions[index], attachmentsNumber: (attachmentsNumber - count) <= 0 ? 0 : (attachmentsNumber - count)}
      setData({...data, questions})

    } catch (e) {
      errorlog("error in updatePerimeterQuestion()", e)
    }
  }

  function prepareChoices(question, lookup) {
    const id = question?.id;
    const type = question?.type;
    let choiche = question?.choiche || []

    if (id === 7) showlog("prepareChoices for question 7", question);

    // in base all'id della domanda, imposto la lista da considerare
    if (id === 4) choiche = lookup?.lookupAtecoNaceCodes || []
    if (id === 7) choiche = lookup?.nationalType === 0 ? (lookup?.lookupItalianRegions || []) : (lookup?.lookupNations || [])
    if (id === 16) choiche = lookup?.lookupNations || []
    if (id === 17) choiche = lookup?.lookupNations || []
    if (id === 18) choiche = lookup?.lookupNations || []
    if (id === 19) choiche = lookup?.lookupNations || []

    return choiche
  }

  function checkIfQuestionsAreCompleted(questions) {
    if (questions?.filter(({isComplete}) => isComplete)?.length === questions?.length) setReady(true)
    else setReady(false)
  }

  function checkQuestions(profilingQuestions, lookup) {
    try {
      // controllo se le domande sono tutte complete (hanno almeno una risposta?)
      const updatedQuestions = [...(profilingQuestions || [])]?.map((q) => {
        // let isComplete = false;
        // if (q?.answers?.value?.filter(onlyNotNull)?.length === q?.choiche?.length) isComplete = true;
        return {
          ...q,
          choiche: prepareChoices(q, lookup),
          isComplete: checkQuestionStatus(q)
        }
      })

      // showlog('are all complete?', updatedQuestions?.filter(({isComplete}) => isComplete)?.length === updatedQuestions?.length);
      // if (updatedQuestions?.filter(({isComplete}) => isComplete)?.length === updatedQuestions?.length) setReady(true)

      checkIfQuestionsAreCompleted(updatedQuestions)

      return updatedQuestions
    } catch (e) {
      errorlog("in checkIfComplete()", e)
      setReady(false)
      return profilingQuestions

    }
  }

  function toggleQuestion(questionId) {
    try {
      showlog('toggleQuestion', questionId);

      setData(prevData => ({
        ...prevData,
        questions: (prevData.questions || []).map((q) => {
          if (q?.questionId === questionId) {
            return {...q, isOpen: !q.isOpen || false};
          }
          return q;
        })
      }));

    } catch (e) {
      errorlog("in toggleQuestion()", e)
    }
  }

  async function generatePerimeterPdf() {
    try {
      setWaitingPDF(true)
      const input = document.getElementById('perimeter-container');
      const savePdfButton = document.getElementById('print-pdf-button');
      const headerElement = document.getElementById('perimetral-question-name');

      // --- 1. PREPARAZIONE: RIMUOVI E MEMORIZZA LA POSIZIONE DEL PULSANTE ---
      let buttonParent = null;
      let buttonNextSibling = null;

      if (savePdfButton) {
        buttonParent = savePdfButton.parentNode;
        buttonNextSibling = savePdfButton.nextElementSibling;
        savePdfButton.remove();
      }

      // --- 2. INIZIALIZZA PDF E VARIABILI DI PAGINAZIONE ---
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pdfPageWidth = pdf.internal.pageSize.getWidth();
      const pdfPageHeight = pdf.internal.pageSize.getHeight();
      const pageMargin = 10;

      let yPosition = pageMargin; // Inizia sotto il margine superiore

      // -----------------------------------------------------
      // FASE A: CATTURA E AGGIUNGI L'INTESTAZIONE
      // -----------------------------------------------------
      if (headerElement) {
        // A. Cattura l'intestazione
        const headerCanvas = await html2canvas(headerElement, {
          scale: 2,
          logging: false,
          useCORS: true
        });
        const headerImgData = headerCanvas.toDataURL('image/png');

        // B. Calcola l'altezza dell'intestazione in mm
        const headerRatio = headerCanvas.width / pdfPageWidth;
        const headerHeightMM = headerCanvas.height / headerRatio;

        // C. Aggiungi l'intestazione alla pagina 1
        pdf.addImage(
          headerImgData,
          'PNG',
          pageMargin / 2,
          yPosition,
          pdfPageWidth - pageMargin,
          headerHeightMM
        );

        // D. Aggiorna la posizione Y per il contenuto successivo (le Card)
        yPosition += headerHeightMM + 10; // 10mm di spazio dopo l'intestazione
      }

      // -----------------------------------------------------
      // FASE B: CATTURA E AGGIUNGI LE CARD (PAGINAZIONE)
      // -----------------------------------------------------
      const cardElements = input.querySelectorAll('[id^="perimeter-card-question-"]');

      if (!cardElements || cardElements.length === 0) {
        // Se non ci sono card, almeno l'header è stato stampato.
        console.warn("Nessuna Card trovata, solo l'intestazione è stata stampata.");
      }

      for (const card of cardElements) {

        // A. Cattura SOLO la Card corrente
        const canvas = await html2canvas(card, {
          scale: 2,
          logging: false,
          useCORS: true
        });
        const imgData = canvas.toDataURL('image/png');

        // B. Calcola l'altezza della Card in mm
        const canvasWidth = canvas.width;
        const canvasHeight = canvas.height;
        const ratio = canvasWidth / pdfPageWidth;
        const elementHeightMM = canvasHeight / ratio;

        // C. VERIFICA INTERRUZIONE DI PAGINA
        // Se la Card non entra nello spazio rimanente:
        if (yPosition + elementHeightMM > pdfPageHeight - pageMargin) {
          pdf.addPage();
          yPosition = pageMargin; // Inizia all'inizio della nuova pagina
        }

        // D. AGGIUNGI L'IMMAGINE DELLA CARD
        pdf.addImage(
          imgData,
          'PNG',
          pageMargin / 2,
          yPosition,
          pdfPageWidth - pageMargin,
          elementHeightMM
        );

        // E. AGGIORNA LA POSIZIONE Y PER LA PROSSIMA CARD
        yPosition += elementHeightMM + 5; // 5mm di spazio tra le Card
      }

      // --- 3. RIPRISTINO DEL PULSANTE ---
      if (buttonParent) {
        if (buttonNextSibling) {
          buttonParent.insertBefore(savePdfButton, buttonNextSibling);
        } else {
          buttonParent.appendChild(savePdfButton);
        }
      }

      // 4. Scarica il PDF
      pdf.save("perimeter_questions_" + evaluationId + ".pdf");
    } catch (e) {
      showlog("error generating PDF", e)
    } finally {
      setWaitingPDF(false)
    }
  }

  function PdfButton() {
    // const isToShow = (!!isUserRole(role.ADMIN) || !!isUserRole(role.SR_ADMIN)) ? false : ready;
    const isToShow = (
      !!isUserRole(role.ARB_OPERATOR)
      || !!isUserRole(role.PROJECT_MANAGER)
      || !!isUserRole(role.ADMIN)
      || !!isUserRole(role.SR_ADMIN)
    ) && ready;
    if (isToShow) {
      return (
        <div style={{display: "flex", flexDirection: "column", alignItems: "flex-end"}}>
          <div>
            <Button color={"primary"} onClick={generatePerimeterPdf}>
              {waitingPDF && <Spinner color={"#fffa"} className="spinner-border-sm mr-1"/>}
              Esporta PDF
            </Button>
          </div>
        </div>
      )
    }
    else return null
  }

  function ConfirmButton() {
    const isDisabled = !(!!isUserRole(role.ADMIN) || !!isUserRole(role.SR_ADMIN)) ? false : !ready;
    return (
      <div style={{display: "flex", flexDirection: "column", alignItems: "flex-end"}}>
        <div>
          <Button
            color={"primary"}
            className={isDisabled ? "disabled" : ""}
            onClick={async clickEvent => {
              try {
                clickEvent.stopPropagation();
                clickEvent.preventDefault();


                if (!waitingConfirm) {
                  setWaitingConfirm(true)

                  if (!ready) throw new Error(translate("Please complete all the questions"))

                  if (data.status === RATING_STATUS.perimetralQuestionInProgress.id) {
                    if (isUserRole(role.ADMIN) || isUserRole(role.SR_ADMIN)) {
                      await savePerimetral(evaluationId, RATING_STATUS.perimetralQuestionCompleted.id)
                    }
                    setRedirectPath(goAwayPath)
                  } else if (data.status === RATING_STATUS.perimetralQuestionCompleted.id) {
                    if (isUserRole(role.ARB_OPERATOR) || isUserRole(role.PROJECT_MANAGER)) {
                      await savePerimetral(evaluationId, RATING_STATUS.perimetralQuestionValidated.id)
                      setRedirectPath(configurationPath)
                    } else setRedirectPath(goAwayPath)
                  } else if (data.status === RATING_STATUS.perimetralQuestionValidated.id) {
                    if (isUserRole(role.ARB_OPERATOR) || isUserRole(role.PROJECT_MANAGER)) {
                      setRedirectPath(configurationPath)
                    } else setRedirectPath(goAwayPath)
                  }

                  // new Promise((success, fail) => {
                  //   if (!!isUserRole(role.ADMIN) || !!isUserRole(role.SR_ADMIN)) {
                  //
                  //     if (!ready) return fail(translate("Please complete all the questions"))
                  //
                  //     if (data.status > RATING_STATUS.perimetralQuestionCompleted.id) return success()
                  //     else {
                  //       Promise.race([
                  //         httpTimer.start(),
                  //         savePerimetral(evaluationId, RATING_STATUS.perimetralQuestionAccepted.id)
                  //       ])
                  //         .then(success)
                  //         .catch(fail)
                  //
                  //     }
                  //   } else return Promise.resolve()
                  // })
                  //   .then(result => {
                  //
                  //     if (data.status === RATING_STATUS.perimetralQuestionCompleted.id) {
                  // if (!!isUserRole(role.ADMIN) || !!isUserRole(role.SR_ADMIN)) {
                  //   setRedirectPath(evaluationPath)
                  // } else setRedirectPath(goAwayPath)
                  //     } else {
                  //       setRedirectPath(evaluationPath)
                  //     }
                  //
                  //     // // if (!!data.status >= 20 || !!data.status === 25) {
                  //     // if (!!data?.status >= 20) setRedirectPath(evaluationPath)
                  //     // // else if (!!data.status === 25) setRedirectPath(configurationPath)
                  //     // else setRedirectPath(evaluationPath) // setRedirectPath(goAwayPath)
                  //   })
                  //   .catch(setError)
                  //   .finally(() => setWaitingConfirm(false))
                }

              } catch (e) {
                setError(e)
              } finally {
                setWaitingConfirm(false)
              }

              // clickEvent.stopPropagation();
              // clickEvent.preventDefault();
              //
              //
              // if (!waitingConfirm) {
              //   setWaitingConfirm(true)
              //
              //
              //   new Promise((success, fail) => {
              //     if (!!isUserRole(role.ADMIN) || !!isUserRole(role.SR_ADMIN)) {
              //
              //       if (!ready) return fail(translate("Please complete all the questions"))
              //
              //       if (data.status > RATING_STATUS.perimetralQuestionCompleted.id) return success()
              //       else {
              //         Promise.race([
              //           httpTimer.start(),
              //           savePerimetral(evaluationId)
              //         ])
              //           .then(success)
              //           .catch(fail)
              //
              //       }
              //     } else return Promise.resolve()
              //   })
              //     .then(result => {
              //
              //       if (data.status === RATING_STATUS.perimetralQuestionCompleted.id) {
              //         if (!!isUserRole(role.ADMIN) || !!isUserRole(role.SR_ADMIN)) {
              //           setRedirectPath(evaluationPath)
              //         } else setRedirectPath(goAwayPath)
              //       } else {
              //         setRedirectPath(evaluationPath)
              //       }
              //
              //       // // if (!!data.status >= 20 || !!data.status === 25) {
              //       // if (!!data?.status >= 20) setRedirectPath(evaluationPath)
              //       // // else if (!!data.status === 25) setRedirectPath(configurationPath)
              //       // else setRedirectPath(evaluationPath) // setRedirectPath(goAwayPath)
              //     })
              //     .catch(setError)
              //     .finally(() => setWaitingConfirm(false))
              // }
            }}
          >
            {
              waitingConfirm
                ? (
                  <React.Fragment>
                    <Spinner color={"#fffa"} className="spinner-border-sm mr-1"/>
                    <span>{translate("Loading_")}</span>
                  </React.Fragment>
                )
                : (
                  // !!isUserRole(role.ADMIN) || !!isUserRole(role.SR_ADMIN)
                  //   ? translate("Confirm") : translate("BackToEvaluation")

                  // (
                  //   (!!this.props.location.state.comeFromStateConfigurationInProgress) ? "Torna alla configurazione"
                  //     : ((!!this.props.location.state.cameFromStatusHigherThan20)
                  //       ? "Torna alla valutazione" : "Valida")
                  // )

                  (data.status === RATING_STATUS.perimetralQuestionInProgress.id) ? (
                    (!!isUserRole(role.ADMIN) || !!isUserRole(role.SR_ADMIN)) ? (
                      translate("Confirm")
                    ) : translate("BackToEvaluations")
                  ) : (
                    (data.status === RATING_STATUS.perimetralQuestionCompleted.id)
                      ? (
                        (!!isUserRole(role.ARB_OPERATOR) || !!isUserRole(role.PROJECT_MANAGER)) ? (
                          translate("Validate")
                        ) : translate("BackToEvaluations")
                      )
                      : (
                        (data.status === RATING_STATUS.perimetralQuestionValidated.id)
                          ? (
                            (!!isUserRole(role.ARB_OPERATOR) || !!isUserRole(role.PROJECT_MANAGER))
                              ? translate("BackToEvaluation") : translate("BackToEvaluation")
                          )
                          : (
                            translate("BackToEvaluations")

                          )
                      )
                  )
                )
            }
          </Button>


          {/*<ActionButton*/}
          {/*  // visible={!isReadOnly() || !!isUserRole(role.ADMIN) || !!isUserRole(role.SR_ADMIN)}*/}
          {/*  className={isDisabled ? "disabled" : ""}*/}
          {/*  buttonText={*/}
          {/*    (!!isUserRole(role.ADMIN) || !!isUserRole(role.SR_ADMIN))*/}
          {/*      ? translate("Confirm")*/}
          {/*      : translate("BackToEvaluation")*/}

          {/*    // !!isUserRole(role.ARB_OPERATOR)*/}
          {/*    //   ? "Conferma" : ((!!this.props.location.state.comeFromStateConfigurationInProgress) ? "Torna alla configurazione"*/}
          {/*    //     : ((!!this.props.location.state.cameFromStatusHigherThan20)*/}
          {/*    //       ? "Torna alla valutazione" : "Valida"))*/}
          {/*  }*/}
          {/*  promise={() => {*/}
          {/*    // setWaitingConfirm(true)*/}
          {/*    if (!!isUserRole(role.ADMIN) || !!isUserRole(role.SR_ADMIN)) {*/}

          {/*      if (!ready) return Promise.reject(translate("Please complete all the questions"))*/}

          {/*      if (!!props?.location?.state?.cameFromStatusHigherThan20 || !!props?.location?.state?.comeFromStateConfigurationInProgress) {*/}
          {/*        return Promise.resolve()*/}
          {/*      } else {*/}
          {/*        showlog("lancio chiamata salvataggio")*/}
          {/*        // setWaitingConfirm(true)*/}
          {/*        return savePerimetral(props?.match?.params?.id);*/}
          {/*      }*/}
          {/*    } else return Promise.resolve()*/}

          {/*  }}*/}
          {/*  onResult={result => {*/}
          {/*    showlog('onResult()');*/}

          {/*    setWaitingConfirm(false)*/}
          {/*    if (*/}
          {/*      !!props?.location?.state?.cameFromStatusHigherThan20*/}
          {/*      || !!props?.location?.state?.comeFromStateConfigurationInProgress*/}
          {/*    ) {*/}

          {/*      if (!!props?.location?.state?.cameFromStatusHigherThan20) setRedirectPath(evaluationPath)*/}
          {/*      else if (!!props?.location?.state?.comeFromStateConfigurationInProgress) setRedirectPath(configurationPath)*/}
          {/*    } else setRedirectPath(evaluationPath) // setRedirectPath(goAwayPath)*/}

          {/*  }}*/}
          {/*  onError={(err) => {*/}
          {/*    showlog("ci sono errori")*/}
          {/*    setError(err)*/}
          {/*    setWaitingConfirm(false)*/}
          {/*  }}*/}
          {/*/>*/}
        </div>
        {
          waitingConfirm &&
          <label className={"canTakeAWhileLabel"}>{translate("OperationMayTakeAWhile")}</label>
        }
      </div>
    )
  }

  return (


    <Suspense fallback={inWaiting}>
      {
        !!error &&
        <ErrorMessageModalComponent
          message={extractErrorMessage(error)}
          noheader={true}
          noHazard={true}
          onClose={() => {
            setError(null)
            // this.setState({
            // 	...this.state,
            // 	errorMessage: null
            // })
          }}
        />
      }

      {
        !!attachmentModal &&
        <PerimeterQuestionAttachmentModal
          questionId={attachmentModal}
          evaluationId={evaluationId}
          // files={[] /*this.state.attachmentModal*/}
          disableUpload={false}
          disableDelete={false}
          onAttachmentUploaded={attachments => {
            updatePerimeterQuestionAttachmentsNumber(attachmentModal, true, attachments?.length)
          }}
          onAttachmentDelete={attachmentIds => {
            updatePerimeterQuestionAttachmentsNumber(attachmentModal, false, attachmentIds?.length)
          }}
          onClose={() => setAttachmentModal(null)}
        />
      }

      {!!redirectPath && <Redirect to={redirectPath}/>}

      <PageTitle
        breadCrumbItems={[
          {
            label: "SI Rating" /*
								Object.keys( role )
									.map( roleObjectName => role[ roleObjectName ] )
									.filter( roleObject => roleObject.name === localStorage.getItem("role") )
									.reduce( getLastElementOr, "Nessun Ruolo" )
									.label */
            , path: PATH_PREFIX + "/welcome"
          },
          {
            label: translate("Evaluations"),
            path: PATH_PREFIX + "/super-admin/si-rating/" + translate("evaluations")
          },
          {label: translate("Perimetral Questions"), active: true}
        ]}
        title={"Profilazione"}
      />

      <Card id={"perimeter-container"}>
        <CardHeader>
          <div className={"rating-header-name"}>
            <span className="float-right">
						  <PdfButton/>
            </span>
            <div id={"perimetral-question-name"}>

            Domande di perimetro per la valutazione &nbsp;
            <strong className={""}>{
              props?.location?.state?.Nome
              || evaluationId
            }</strong>
            </div>
            {/*<div*/}
            {/*  id={"print-pdf-button"}*/}
            {/*  style={{margin: "10px", padding: "10px", backgroundColor: "pink"}}*/}
            {/*  onClick={generatePerimeterPdf}*/}
            {/*>*/}
            {/*  STAMPA PDF*/}
            {/*</div>*/}
          </div>

          <Label for="subThemes">{translate("Filter")}&nbsp;&nbsp;&nbsp;&nbsp;</Label>
          <Select
            className="react-select question-filter-select"
            classNamePrefix="react-select"
            name="question-filter"
            id="question-filter"
            onChange={changeEvent => {
              setActiveFilter(changeEvent.value)
            }}
            options={[
              {label: translate("All"), value: -1},
              {label: translate("To Answer"), value: 0},
              {label: translate("Answered"), value: 1}
            ]}
            placeholder={<span className={"select-placeholder"}>{translate("Select filter")}</span>}
          />

          <span className="float-right">
						<ConfirmButton/>
          </span>

        </CardHeader>
        <CardBody>

          {
            isNotEmptyArray(data?.questions)
              ? (
                data?.questions
                  .filter(question => activeFilter === -1 || (activeFilter === 0 && !question.isComplete) || (activeFilter === 1 && question.isComplete))
                  .map((question, questionIndex) => {

                    let questionColorPolicyClass = (
                      isReadOnly()
                        ? COLOR_POLICY.disabled.textClass
                        : question.isComplete
                          ? COLOR_POLICY.validated.textClass
                          : COLOR_POLICY.edit.textClass
                    );

                    return (
                      <Card className="mb-0 card-no-break" id={"perimeter-card-question-" + question?.id}>

                        <div className={"space-between"}>

                          {/*   ---   Domanda   ---   */}
                          <div
                            className={"custom-accordion-title question-name-text tree_comander pt-2 pb-2 perimetral-question-text " + questionColorPolicyClass}
                          >
                            {question?.id === 38 ? "2a" : question?.id} - {question?.description}
                            <React.Fragment key={"gl-" + question.id}>
                              <i
                                id={"qgl-" + question.id}
                                className={"dripicons-information question-info-icon mt-1 " + questionColorPolicyClass}
                                onClick={clickEvent => {
                                  clickEvent.stopPropagation();
                                }}
                              />
                              <UncontrolledPopover
                                placement="top"
                                target={"qgl-" + question.id}
                                trigger="legacy"
                              >
                                <PopoverHeader>{ translate("GuideLine") }</PopoverHeader>
                                <PopoverBody>{question?.guideline}</PopoverBody>
                              </UncontrolledPopover>
                            </React.Fragment>
                          </div>

                          {/*   ---   Allegati   ---   */}
                          <div
                            className={"flex-row cursor-pointer p-1 position-relative"}
                            onClick={clickEvent => setAttachmentModal(question?.id)}
                          >
                            <i
                              id={"allegati-" + question?.id}
                              className={"mdi mdi-attachment perimeter-question-attachment-icon "}
                            />
                            {
                              question?.attachmentsNumber > 0 &&
                              <span className="position-absolute top-0 badge rounded-pill bg-danger white-text">{question?.attachmentsNumber}</span>
                            }
                            <label className={"perimeter-attachments-label cursor-pointer"}>Allegati</label>
                          </div>

                        </div>
                        <CardBody className={"margin-left"}>
                          <RenderQuestions
                            evaluationId={evaluationId}
                            question={question}
                            italianRegions={question?.id === 7 ? data.lookup?.lookupItalianRegions : []}
                            updateQuestion={updatePerimeterQuestion}
                            isDisabled={isReadOnly()}
                            onError={setError}
                          />
                        </CardBody>
                        {/*</Collapse>*/}
                      </Card>
                    );
                  })
              )
              : (
                <WaitingOrNodataMessage
                  waiting={inWait}
                  fullHeight={true}
                  nodataMessage={"Nessun Dato"}
                />
              )
          }


          <GotoTopComponent/>
          <br/>
          <span className="float-right">
						<ConfirmButton/>
          </span>


        </CardBody>
      </Card>


    </Suspense>
  );
}

export default withRouter(SIRatingPerimetralQuestionPage);
